import fetchSiteCopy from './fetchSiteCopy';
import { setSiteCopy } from './SiteChrome';

/*
 * Satu baris yang dipanggil setiap route action situs publik sebelum merender.
 *
 * Harus di action, bukan di componentDidMount: kalau timpaan baru masuk setelah
 * halaman ter-render, teks akan berkedip dari bawaan ke versi client. Action
 * ditunggu router baik di server maupun saat navigasi di browser, jadi render
 * pertama sudah membawa teks yang benar.
 */
export default async function loadSiteCopy() {
  setSiteCopy(await fetchSiteCopy());
}
